import React, { useState, useEffect } from 'react';
import '../../styles/components/common/ColorPicker.css';

export const colors = [
  '#FF6900', '#FCB900', '#7BDCB5', '#00D084', '#8ED1FC',
  '#0693E3', '#ABB8C3', '#EB144C', '#F78DA7', '#9900EF',
  '#00FFFF', '#FF00FF', '#800000', '#808000', '#4B0082'
];

const ColorPicker = ({ color, onChangeComplete }) => {
  const [selectedColor, setSelectedColor] = useState(color || null);
  const [visible, setVisible] = useState(false);

  const handleColorClick = (newColor) => {
    setSelectedColor(newColor);
    if (onChangeComplete) {
      onChangeComplete({ hex: newColor });
    }
  };

  useEffect(() => {
    setSelectedColor(color);
  }, [color]);

  return (
    <div className={`circle-picker ${visible ? 'visible' : ''}`}>
      {colors.map((colorItem) => (
        <div
          key={colorItem}
          className={`circle ${selectedColor === colorItem ? 'selected' : ''}`}
          style={{ backgroundColor: colorItem }}
          onClick={() => handleColorClick(colorItem)}
        />
      ))}
    </div>
  );
};

export default ColorPicker;
